import firebase from "firebase/app";
import * as firebaseui from "firebaseui";
import { auth } from "./firebase";
import router from "../router";

export const uiConfig = {
    signInOptions: [
        firebase.auth.EmailAuthProvider.PROVIDER_ID
    ],
    signInFlow: 'popup',
    callbacks: {
        signInSuccessWithAuthResult() {
            router.push("/dashboard");
        }
    }
};

export const ui = new firebaseui.auth.AuthUI(auth);